import _ from 'lodash'
import { get, writable } from 'svelte/store'
import { log, warn } from './logger'
import { uid } from './uid'

const Store = writable( {} )

const subscribe = ( type, callback ) => {
  log( '@coldandgoji/utilities', 'subscribe', type )

  if ( !_.isFunction( callback ) ) {
    warn( `↳ callback for ${ type } is not a function` )
    return
  }

  const id = uid()
  const _Store = get( Store )

  _.set( _Store, `${ type }.${ id }`, callback )

  Store.set( _Store )

  return () => {
    log( '@coldandgoji/utilities', 'unsubscribe', type )

    const _Store = get( Store )

    // Remove explicit subscription
    _.unset( _Store, `${ type }.${ id }` )

    Store.set( _Store )
  }
}

const publish = ( type, payload ) => {
  log( '@coldandgoji/utilities', 'publish', type )

  const _Store = get( Store )

  // Get subscriptions
  const subscriptions = _.get( _Store, type )

  // If there are no subscriptions, return early
  if ( _.isEmpty( subscriptions ) ) return

  // Run all callbacks associate with type
  _.each( subscriptions, callback => {
    callback && callback( payload )
  } )
}

export {
  publish,
  subscribe,
}
